/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {INudgeParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeParsedGameData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {TombstoneGameMode} from "../../gamemode/TombstoneGameMode";
import {TombstoneServerDataParser} from "../TombstoneServerDataParser";
import {ITombstoneParsedServerData} from "./ITombstoneParsedServerData";
import {ITombstoneGameData} from "./ITombstoneServerData";
import {TombstoneNoMercy} from "../../TombstoneNoMercy";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";


interface reelPosition {
    reelID:number,
    reelPosition:number
}
type reelPositionWithSymbol = reelPosition & {symbol:string}; // TODO: Yay!

export interface WinLineData {
    amount:number;
    length:number;
    mode:string;
    multipliedAmount:number;
    multiplier:number;
    numberOfCombinations:number;
    symbol:string;
}

export interface WinData {
    winLineData:WinLineData;
    winningPositions:{reelID:number, reelPosition:number}[];
}

export interface BetWayWin {
    amount:number;
    length:number;
    mode:string;
    multipliedAmount:number;
    multiplier:number;
    numberOfCombinations:number;
    symbol:string;
}

export class TombstoneParsedGameData extends SpinParsedGameData implements INudgeParsedGameData, ITombstoneParsedServerData {

    public wins:WinData[];

    private readonly _doReelNudge:boolean[];
    public enhancedBet:boolean;
    public brokeTheBank:boolean;
    private evaluatedArea: string [][];
    public get doReelNudge():boolean[] {
        return this._doReelNudge;
    }

    public accumulatedRoundWin:number;

    private readonly _extraSymbolsOnTop:string[][];
    public get extraSymbolsOnTop():string[][] {
        return this._extraSymbolsOnTop;
    }

    private readonly _superFreespinTriggeredThisSpin:boolean;
    public get superFreespinTriggeredThisSpin():boolean {
        return this._superFreespinTriggeredThisSpin;
    }

    private readonly _overlayWildsBeforeSpin:boolean[][];
    public get overlayWildsBeforeSpin():boolean[][] {
        return this._overlayWildsBeforeSpin;
    }

    private readonly _multiplierOnReel:number[];
    public get multiplierOnReel():number[] {
        return this._multiplierOnReel;
    }

    private readonly _bonusTriggeredThisSpin:boolean;
    public get bonusTriggeredThisSpin():boolean {
        return this._bonusTriggeredThisSpin;
    }

    private readonly _bonusPositions:number[];
    public get bonusPositions():number[] {
        return this._bonusPositions;
    }

    private readonly _numberOfBonusSpinsPlayed:number;
    public get numberOfBonusSpinsPlayed():number {
        return this._numberOfBonusSpinsPlayed;
    }

    private readonly _bonusSpinsLeft:number;
    public get bonusSpinsLeft():number {
        return this._bonusSpinsLeft;
    }

    public get nearWinClientReels(): boolean [] {
        const returnarr: boolean [] = [false, false, false, false, false];

        if(TombstoneGameModuleConfig.initData.buyFeatureName === "SUPER_FREESPIN") {
            return returnarr;
        }
        // if "B", arr idx 4: true
        if(this.reels[0].indexOf("B") > -1 && this.reels[0].indexOf("B") < 2) {
            returnarr[4] = true;
        }

        if((this.reels[1].indexOf("S") > 0 && this.reels[1].indexOf("S") < 4) && (this.reels[2].indexOf("S") > 0 && this.reels[2].indexOf("S") < 4)) {
            returnarr[3] = true;
        }

        return returnarr;
    }

    private boostedBet:boolean;
    public buyFeatureName:string;

    constructor(rawData:ITombstoneGameData, dataParser:TombstoneServerDataParser) {
        super(rawData, dataParser);
        if (TombstoneNoMercy.isActionSpinsActive){
            return;
        }

        this._doReelNudge = dataParser.parseDoReelNudge(rawData);
        this._extraSymbolsOnTop = dataParser.parseExtraSymbolsOnTop(rawData);
        this._superFreespinTriggeredThisSpin = dataParser.parseSuperFreespinTriggeredThisSpin(rawData);
        this._overlayWildsBeforeSpin = dataParser.parseOverlayWildsBeforeSpin(rawData);
        this._multiplierOnReel = dataParser.parseMultiplierOnReel(rawData);
        this._bonusTriggeredThisSpin = dataParser.parseBonusTriggeredThisSpin(rawData);
        this._bonusPositions = dataParser.parseBonusPositions(rawData);
        this._numberOfBonusSpinsPlayed = dataParser.parseNumberOfBonusSpinsPlayed(rawData);
        this._bonusSpinsLeft = dataParser.parseBonusSpinsLeft(rawData);
        this.enhancedBet = rawData.enhancedBet;
        this.brokeTheBank = rawData.brokeTheBank;
        this.evaluatedArea = rawData.evaluatedArea;
        this.accumulatedRoundWin  = Number(rawData.accumulatedRoundWin);
        this.boostedBet = rawData.boostedBetPlayed;

       // Call to init data
        TombstoneNoMercy.api.events.on(APIEvent.ACTION_SPINS_BET, (betData:APIFeatureBetEventData) => {
            if(TombstoneGameModuleConfig.initData.featureBuyTimesBetValue) {
                for (let index = 0; index < TombstoneGameModuleConfig.initData.featureBuyTimesBetValue.length; index++) {
                    if (TombstoneGameModuleConfig.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                        this.buyFeatureName = betData.featureName;
                        Logger.logDev("Opted Feature : ", this.buyFeatureName);
                        break;
                    }
                }
            }
        });
    }

    protected isFeatureTotalWin():boolean {
        return this.superFreespinTriggeredThisSpin || this.mode === TombstoneGameMode.SUPER_FREESPIN;
    }

    protected isNextFeatureTotalWin():boolean {
        return this.nextMode === TombstoneGameMode.SUPER_FREESPIN;
    }

    /*
        betWayWins
        :
        Array(1)
        0:
            amount : 4
            length : 4
            mode : "NORMAL"
            multipliedAmount : 4
            multiplier : 1
            numberOfCombinations : 4

            reelWinPositions: Array(5) // Remove
            0 : (3) [false, true, true]
            1 : (3) [false, true, true]
            2 : (3) [false, false, true]
            3 : (3) [false, false, true]
            4 : (3) [false, false, false]

            symbol: "M1"
     */

    public getWinPositions(symId:string, length:number): PIXI.Point [] {
        const winPositions: PIXI.Point[] = [];
        const winPosRangesPerReel: PIXI.Point [] = [ // min, max
            new PIXI.Point(1, 2),
            new PIXI.Point(0, 2),
            new PIXI.Point(0, 2),
            new PIXI.Point(0, 2),
            new PIXI.Point(1, 2)
        ];


        this.evaluatedArea.forEach((reel, rId) => {
            reel.forEach((sym, sId) => {
                if(rId <= (length - 1) && (sId >= winPosRangesPerReel[rId].x && sId <= winPosRangesPerReel[rId].y) &&(sym === symId || "W")) {
                    winPositions.push(new PIXI.Point(rId, sId));
                }
            });
        });

        return winPositions;
    }


    public isWinAboveStake(): boolean {
        return TombstoneNoMercy.api.gameClientConfiguration.belowStakeWinRestriction && this.getAccumulatedRoundWin() > this.getBetPrice();
    }

    public getBetPrice(): number {
        const betLevel: string = TombstoneNoMercy.api.freeBets.hasFreeBets() ? TombstoneNoMercy.api.freeBets.getBet() : TombstoneNoMercy.api.betLevel.getLevel();
        let price: number = this?.playedBetValue || parseFloat(betLevel);
        if (this.wasFeatureBuy || this.boostedBet) {
            for (let index = 0; index < TombstoneGameModuleConfig.initData.featureBuyTimesBetValue.length; index++) {
                if (TombstoneGameModuleConfig.initData.featureBuyTimesBetValue[index].name === TombstoneGameModuleConfig.initData.buyFeatureName) {
                    price *= TombstoneGameModuleConfig.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    private getBasePlayedBetValue():number {
        let betLevel = TombstoneNoMercy.api.freeBets.hasFreeBets() ? TombstoneNoMercy.api.freeBets.getBet() : TombstoneNoMercy.api.betLevel.getLevel();
        return this?.playedBetValue || parseFloat(betLevel);
    }

    public getBuyFeaturePrice():number {
        let price = this.getBasePlayedBetValue();
        if(this.wasFeatureBuy) {
            for(let index = 0; index < TombstoneGameModuleConfig.initData.featureBuyTimesBetValue.length; index++) {
                if(TombstoneGameModuleConfig.initData.featureBuyTimesBetValue[index].name === TombstoneGameModuleConfig.initData.buyFeatureName) {
                    price *= TombstoneGameModuleConfig.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    public isWinBelowStake(): boolean {
        const activeBetFeature = SlotGame.api.betFeatureController.getActiveBetFeature();
        let cost:number = this.getBetPrice();

        //debugger;
        if(activeBetFeature) {
            cost = activeBetFeature.getTotalCost();
            //debugger;
        }


        return TombstoneNoMercy.api.gameClientConfiguration.belowStakeWinRestriction && (this.accumulatedRoundWin <= cost);
    }

    public getAccumulatedRoundWin(): number {
        return this.accumulatedRoundWin;
    }
}